
















































































































































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { listMixin } from "@/mixins/listMixin";
import {
  GetDictionaryData,
  GetKepuList,
  DelKepu,
  PatchEditKepu,
  UploadFile,
  GetTopicList,
  PostReply,
  GetReplyList,
} from "@/request/common";
import MainHeader from "@/components/main-header.vue";
import ManageLeft from "@/components/manage-left.vue";
@Component({
  components: {
    MainHeader,
    ManageLeft,
  },
})
export default class Name extends mixins(listMixin) {
  private years: any = [];
  private ifShowEdit: any = false;
  private addType: any = "";
  private data: any[] = [];
  private edit: any = false;
  private ifShowAddLiangbiao: any = false;
  private manageType: any = "";
  private ifShowManage: any = false;
  private editData: any = {};
  private disabledDate: any = this.beginDate();
  private get user() {
    return this.$store.state.user;
  }
  private get patient() {
    return this.$store.state.patient;
  }
  private get systemInfo() {
    return this.$store.state.systemInfo;
  }
  private goTiqu(item: any) {
    this.$router.push({
      path: "/main/knowledge/extract",
      query: {
        type: "文献",
        id: item.id,
      },
    });
  }
  private beginDate() {
    const self = this;
    return {
      disabledDate(time: any) {
        return time.getTime() > Date.now() - 8.64e7;
      },
    };
  }
  private openUrl(url: any) {
    window.open(url);
  }
  private editStatus(item: any) {
    let type: any = "";
    if (item.check_status === "未发布") {
      type = "已发布";
    } else if (item.check_status === "已发布") {
      type = "未发布";
    }

    PatchEditKepu(this, item.id, { check_status: type }).then((res: any) => {
      this.$message.success(type == "未发布" ? "撤回成功！" : "发布成功！");
      this.getList();
    });
  }
  private upload(file: any) {
    const fileObj = file.file;
    // FormData 对象
    const form = new FormData();
    // 文件对象
    form.append("file", fileObj);
    const loading = this.$loading({
      lock: true,
      text: "上传中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    UploadFile(this, form, loading).then((res: any) => {
      this.editData["原文"] = res.data.file_url;
      this.$forceUpdate();
    });
  }
  private openHuifu(item: any) {
    if (item) {
      this.editData = JSON.parse(JSON.stringify(item));
      const params: any = {
        params: {
          topic: item.id,
        },
      };
      const loading = this.$loading({
        lock: true,
        text: "加载中……",
        spinner: "el-icon-loading",
        customClass: "loadClass",
        background: "rgba(255, 255, 255, 0.7)",
      });
      GetReplyList(this, params, loading).then((res: any) => {
        this.editData.replay = res.data;
        this.ifShowEdit = true;
        console.log(this.editData);
      });
    } else {
      this.editData = {};
      this.ifShowEdit = true;
    }
  }
  private addSure() {
    if (!this.editData["回复"]) {
      this.$message.warning("请输入回复内容！");
      return;
    }
    const params: any = {
      topic: this.editData.id,
      content: this.editData["回复"],
    };
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    PostReply(this, params, loading).then((res: any) => {
      this.ifShowEdit = false;
      this.getList();
    });
  }
  private openManage(type: any) {
    this.manageType = type;
    this.ifShowManage = true;
  }
  private goEdit(item: any) {
    this.$router.push({
      path: "/main/manage/edit",
      query: {
        id: item.id,
      },
    });
  }
  private delTem(item: any) {
    this.$confirm("您是否确定删除？", "删除", {
      customClass: "commonConfirm",
    }).then(() => {
      const loading = this.$loading({
        lock: true,
        text: "加载中……",
        spinner: "el-icon-loading",
        customClass: "loadClass",
        background: "rgba(255, 255, 255, 0.7)",
      });
      DelKepu(this, item.id, loading).then((res: any) => {
        this.$message.success("删除成功");
        this.getList();
      });
    });
  }
  private getYears() {
    const currentYear = new Date().getFullYear();
    const years: string[] = [];

    for (let i = 0; i < 20; i++) {
      years.push((currentYear - i).toString());
    }

    this.years = years;
  }
  getList() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params: any = {
      params: {
        ordering: this.filters.ordering,
        page: this.filters.current_page,
        limit: 10,
        search: this.filters.search,
      },
    };
    if (this.filters["回复状态"]) {
      params.params.is_replied = this.filters["回复状态"];
    }
    GetTopicList(this, params, loading).then((res: any) => {
      this.data = res.data;
      this.filters.total_count = res.total;
      if (this.data.length > 0) {
        this.ifShowEmpty = false;
      } else {
        this.ifShowEmpty = true;
      }
    });
  }
  mounted() {
    if (localStorage.getItem("literatureFilter")) {
      this.filters = JSON.parse(
        localStorage.getItem("literatureFilter") as any
      );
    }
    this.getList();
    this.getYears();
  }
}
